import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  html {
    margin: 0;
    padding: 0;
    font-family: 'Roboto', sans-serif;
    font-size: 18px;
    line-height: 1.4;
    font-weight: 100;
    height: 100vh; 
  }

  body {
    display: flex;
    flex-direction: column;
    height: 100vh; 
  }

  * {
    box-sizing: border-box;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 300;
    margin: 0;
    padding: 0;
  }

  #container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
`;
